export const toUnit = (v: number | string | undefined) =>
  !v || /^([0-9]+(px|em|rem|%|vh)|auto)/.test(v.toString()) ? v : `${v}px`
